import React from "react"
import "./home.css"
import Header from "../../components/header/header"
import Welcome from "../../components/welcome/welcome"
import Aboutme from "../../components/aboutMe/aboutme"

import { Routes, Route } from "react-router-dom"
import Skills from "../../components/skills/skills"
import Project from "../../components/projects/project"
import Contactme from "../../components/contactMe/contactme"

export default function Home(){
    return(
        <main className="homeMain">
            <header className="ho home_header">
                <Header/>
            </header>

            <div className="home_container">
                <div className="pages">
                    <Routes>
                        <Route path="/contactme" element={<Contactme/>}/>
                        <Route path="/projects" element={<Project/>}/>
                        <Route path="/skills" element={<Skills/>}/>
                        <Route path="/about_me" element={<Aboutme/>}/>
                        <Route path="/" element={<Welcome/>}/>
                    </Routes>
                </div>
            
            </div>           
            
        </main>
    )
}